// extracted by mini-css-extract-plugin
export default {"container":"patient-qrcode-page_container__zgpYO","wrapper":"patient-qrcode-page_wrapper__19mYX"};